import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-moovement-svg',
  imports: [],
  templateUrl: './moovement-svg.component.html',
  styleUrl: './moovement-svg.component.css'
})
export class MoovementSvgComponent {
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() colored: boolean = false
}
